export const EDIT_PROJECT_USER = "EDIT_PROJECT_USER"
export const PROJECT_USER_SUCCESS = "PROJECT_USER_SUCCESS"
export const RESET_PROJECT_USER = "RESET_PROJECT_USER";
export const SET_CURRENT_PROJECT = "SET_CURRENT_PROJECT";
export const UNSET_CURRENT_PROJECT = "UNSET_CURRENT_PROJECT";